import { ElementsIconProps } from '../components';

export function HappyFaceIcon(props: ElementsIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <g clipPath="url(#clip0_771_624)">
        <circle cx="12" cy="12" r="9" fill="#4AF196" />
        <path
          d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM15.5 11C16.33 11 17 10.33 17 9.5C17 8.67 16.33 8 15.5 8C14.67 8 14 8.67 14 9.5C14 10.33 14.67 11 15.5 11ZM8.5 11C9.33 11 10 10.33 10 9.5C10 8.67 9.33 8 8.5 8C7.67 8 7 8.67 7 9.5C7 10.33 7.67 11 8.5 11ZM12 17.5C14.03 17.5 15.8 16.39 16.75 14.75C16.94 14.42 16.7 14 16.31 14H7.69C7.31 14 7.06 14.42 7.25 14.75C8.2 16.39 9.97 17.5 12 17.5Z"
          fill="#21543A"
        />
      </g>
      <defs>
        <clipPath id="clip0_771_624">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
